import React, { useState } from 'react';
import { FiFolder, FiTrash2, FiChevronDown } from 'react-icons/fi';
import SettingsModal from '../../../clientSettings/SettingsModal';
import { useHubSite } from '../../shared';
import { Folder, FolderSort, SORT_LABELS } from './docsData';

interface Props {
    folder: Folder;
    files: number;
    onClose: () => void;
    onSave: (f: Folder) => void;
    onDelete: () => void;
}

// Folder settings: rename, re-sort or delete a document folder (spec 420:15325)
const FolderSettingsModal: React.FC<Props> = ({ folder, files, onClose, onSave, onDelete }) => {
    const { host } = useHubSite();
    const [name, setName] = useState(folder.name);
    const [description, setDescription] = useState(folder.description);
    const [sort, setSort] = useState<FolderSort>(folder.sort);

    return <SettingsModal icon={<FiFolder />} title={`Folder Settings — ${folder.name}`} sub={`${files} ${files === 1 ? 'file' : 'files'} · shown on ${host}/${folder.path}/`} onClose={onClose}
        footer={<>
            {/* order: -1 (HubDocs.scss) puts it at the left of the footer */}
            <button type="button" className="hub-btn-danger-outline" onClick={onDelete}><FiTrash2 /> Delete Folder</button>
            <button type="button" className="btn-primary" disabled={!name.trim()} onClick={() => onSave({ ...folder, name: name.trim(), description: description.trim(), sort })}>Save</button>
        </>}>
        <label className="field">
            <span className="label">Folder name</span>
            <input value={name} onChange={e => setName(e.target.value)} />
        </label>
        <label className="field">
            <span className="label">Short description<em>(optional)</em></span>
            <input value={description} onChange={e => setDescription(e.target.value)} />
        </label>
        <label className="field">
            <span className="label">Sort files</span>
            <span className="hub-field-select">
                <select value={sort} onChange={e => setSort(e.target.value as FolderSort)}>
                    {(Object.keys(SORT_LABELS) as FolderSort[]).map(s => <option key={s} value={s}>{SORT_LABELS[s]}</option>)}
                </select>
                <FiChevronDown />
            </span>
        </label>
    </SettingsModal>;
};

export default FolderSettingsModal;
